import { render, staticRenderFns } from "./VvSectionTitleMobile.vue?vue&type=template&id=30162f6b&scoped=true&"
import script from "./VvSectionTitleMobile.vue?vue&type=script&lang=js&"
export * from "./VvSectionTitleMobile.vue?vue&type=script&lang=js&"
import style0 from "./VvSectionTitleMobile.vue?vue&type=style&index=0&id=30162f6b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30162f6b",
  null
  
)

export default component.exports